/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getArrayDecoder,
  getArrayEncoder,
  getStructDecoder,
  getStructEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getNotificationMethodDecoder,
  getNotificationMethodEncoder,
  getNotificationTargetDecoder,
  getNotificationTargetEncoder,
  getNotificationTimingDecoder,
  getNotificationTimingEncoder,
  getSecurityEventTypeDecoder,
  getSecurityEventTypeEncoder,
  type NotificationMethod,
  type NotificationMethodArgs,
  type NotificationTarget,
  type NotificationTargetArgs,
  type NotificationTiming,
  type NotificationTimingArgs,
  type SecurityEventType,
  type SecurityEventTypeArgs,
} from ".";

/** Notification requirements for security events */
export type NotificationRequirement = {
  /** Event type */
  eventType: SecurityEventType;
  /** Notification targets */
  targets: Array<NotificationTarget>;
  /** Notification method */
  method: NotificationMethod;
  /** Notification timing */
  timing: NotificationTiming;
};

export type NotificationRequirementArgs = {
  /** Event type */
  eventType: SecurityEventTypeArgs;
  /** Notification targets */
  targets: Array<NotificationTargetArgs>;
  /** Notification method */
  method: NotificationMethodArgs;
  /** Notification timing */
  timing: NotificationTimingArgs;
};

export function getNotificationRequirementEncoder(): Encoder<NotificationRequirementArgs> {
  return getStructEncoder([
    ["eventType", getSecurityEventTypeEncoder()],
    ["targets", getArrayEncoder(getNotificationTargetEncoder())],
    ["method", getNotificationMethodEncoder()],
    ["timing", getNotificationTimingEncoder()],
  ]);
}

export function getNotificationRequirementDecoder(): Decoder<NotificationRequirement> {
  return getStructDecoder([
    ["eventType", getSecurityEventTypeDecoder()],
    ["targets", getArrayDecoder(getNotificationTargetDecoder())],
    ["method", getNotificationMethodDecoder()],
    ["timing", getNotificationTimingDecoder()],
  ]);
}

export function getNotificationRequirementCodec(): Codec<
  NotificationRequirementArgs,
  NotificationRequirement
> {
  return combineCodec(
    getNotificationRequirementEncoder(),
    getNotificationRequirementDecoder(),
  );
}
